<template>
  <div>
    <h1 class="mb-8 font-bold text-3xl">Dokumenty finansowe</h1>
    <div class="mb-6 flex justify-between items-center">
      <search-filter v-model="form.search" class="w-full max-w-md mr-4" @reset="reset">
        <label class="block text-gray-700">Typ:</label>
        <multiselect-input v-model="form.type" :options="types" class="mt-1 w-full" track_by="id" opt_label="name" :multiple="false" :close_on_select="true" />
        <shtax-checkbox class="pt-4 w-full" v-model:checked.sync="form.booked" :checked="form.booked" label="Zaksięgowany" />
      </search-filter>

    </div>
    <div class="bg-white rounded-md shadow overflow-x-auto">
      <table class="w-full whitespace-nowrap text-xs">
        <tr class="text-left font-bold">
          <th class="px-3 pt-6 pb-4">Kontrahent</th>
          <th class="px-3 pt-6 pb-4">Numer</th>
          <th class="px-3 pt-6 pb-4">Typ</th>
          <th class="px-3 pt-6 pb-4">Data</th>
          <th class="px-3 pt-6 pb-4">Kwota</th>
          <th class="px-3 pt-6 pb-4">Uwagi</th>
        </tr>
        <tr v-for="doc in docs.data" :key="doc.id" class="hover:bg-gray-100 focus-within:bg-gray-100">
          <td class="border-t">
            <span class="px-3 py-2 flex items-center focus:text-shtax-500 whitespace-normal">
              {{ doc.kontrahent }}
            </span>
          </td>
          <td class="border-t">
            <span class="px-3 py-2 flex items-center focus:text-shtax-500">
              {{ doc.numer }}
            </span>
          </td>
          <td class="border-t">
            <span class="px-3 py-2 flex items-center focus:text-shtax-500">
              {{ doc.sygnatura }} <span class="hidden md:inline">- {{ doc.typ}}</span>
            </span>
          </td>
          <td class="border-t">
            <span class="px-3 py-2 flex items-center focus:text-shtax-500">
              {{ doc.data }}
            </span>
          </td>
          <td class="border-t">
            <span class="px-3 py-2 flex items-end focus:text-shtax-500">
              {{ doc.kwota }}
            </span>
          </td>
          <td class="border-t">
            <span class="px-3 py-2 flex items-center focus:text-shtax-500 whitespace-normal">
              {{ doc.tytulem }}
            </span>
          </td>
        </tr>
        <tr v-if="docs.data.length === 0">
          <td class="border-t px-3 py-2" colspan="8">Nie znaleziono dokumentów finansowych.</td>
        </tr>
      </table>
    </div>
    <pagination class="mt-3" :links="docs.links" />
  </div>
</template>

<script>
import Icon from '@/Shared/Icon'
import pickBy from 'lodash/pickBy'
import Layout from '@/Shared/Layout'
import throttle from 'lodash/throttle'
import mapValues from 'lodash/mapValues'
import Pagination from '@/Shared/Pagination'
import SearchFilter from '@/ShtaxComponents/SearchFilter'
import MultiselectInput from '@/ShtaxComponents/MultiselectInput'
import ShtaxCheckbox from '@/ShtaxComponents/Checkbox'

export default {
  metaInfo: { title: 'Dokumenty finansowe' },
  components: {
    Icon,
    Pagination,
    SearchFilter,
    MultiselectInput,
    ShtaxCheckbox
  },
  layout: Layout,
  props: {
    filters: Object,
    docs: Object,
    types: Array,
  },
  data() {
    return {
      form: {
        search: this.filters.search,
        type: this.filters.type,
        booked: this.filters.booked == 'true'
      },
    }
  },
  watch: {
    form: {
      deep: true,
      handler: throttle(function() {
        this.$inertia.get(this.route('fin_docs'), pickBy(this.form), { preserveState: true })
      }, 150),
    },
  },
  methods: {
    reset() {
      this.form = mapValues(this.form, () => null)
    },
  }
}
</script>
